import { useEffect } from 'react';
import { useCookie } from '../context/CookieContext';

const GOOGLE_ANALYTICS_ID = "G-X6NE8YXCZS";

function AnalyticsLoader() {
  const { consent } = useCookie();

  useEffect(() => {
    // STOP! If consent is not explicitly 'accepted', do nothing.
    if (consent !== 'accepted') return;

    // Only run this if you have actually added an ID
    if (GOOGLE_ANALYTICS_ID && GOOGLE_ANALYTICS_ID !== "") {
      console.log("GDPR: Consent given. Loading Analytics...");
      
      // 1. Load the external script
      const script1 = document.createElement("script");
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
      document.head.appendChild(script1);

      // 2. Initialize the script
      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GOOGLE_ANALYTICS_ID}', { 'anonymize_ip': true });
      `;
      document.head.appendChild(script2);
    }
  }, [consent]);

  return null; // Renders nothing visible
}

export default AnalyticsLoader;